import React from 'react';
import { Typography } from '@mui/material';
import { SuccessSVG } from '../assets/SuccessSVG';
import { MainCard } from './MainCard';

export const SuccessCard = () => {
    return (
        <MainCard
            sx={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
                justifyContent: 'center',
                gap: 5,
                height: '100%',
                paddingX: 10,
            }}
        >
            <Typography variant="h4" textAlign="center">
                Su solicitud se ha procesado correctamente
            </Typography>
            <SuccessSVG width={150} />

            <Typography variant="h5" textAlign="center" fontWeight={200}>
                Gracias por utilizar nuestro servicio, su información se ha
                guardado.
            </Typography>
            <Typography variant="body1" fontWeight={200}>
                Ya puede cerrar esta ventana.
            </Typography>
        </MainCard>
    );
};
